import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/breadcrumb/br-1.webp'


const _hoisted_1 = { class: "breadcrumb-wrap" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "breadcrumb-menu list-style" }
const _hoisted_4 = { class: "container br-wrap" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-lg-6 col-md-7 ps-xxl-3" }
const _hoisted_7 = { class: "br-content" }
const _hoisted_8 = { class: "section-subtitle" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "br-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Image"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, _toDisplayString(_ctx.pageTitle), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.mainTitle), 1),
            _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.subTitle), 1)
          ])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}